import { render, staticRenderFns } from "./BaggageDisplay.vue?vue&type=template&id=6ce84fe6&scoped=true"
import script from "./BaggageDisplay.vue?vue&type=script&lang=js"
export * from "./BaggageDisplay.vue?vue&type=script&lang=js"
import style0 from "./BaggageDisplay.vue?vue&type=style&index=0&id=6ce84fe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce84fe6",
  null
  
)

export default component.exports